<template>
  <Dialog :common-dialog="dialog" :dialog-width="dialogWidth">
    <template v-slot:title>
      PM Schedule (<template v-if="lengthSchedule">{{
        preventiveSchedule.length - 1
      }}</template
      ><template v-else>{{ preventiveSchedule.length }}</template
      >)
      <!-- {{ getDuration() }} -->
    </template>
    <template v-slot:body>
      <v-container>
        <v-form
          ref="schedule-auto-generated-form"
          v-model.trim="formValid"
          lazy-validation
          v-on:submit.stop.prevent="validateSchedule"
        >
          <v-row>
            <v-col md="6">
              <p class="red--text">Select checkbox to mark first date*</p>
            </v-col>
            <v-col md="6" v-if="false">
              <div
                v-if="preventiveVisitCreateFlag"
                class="px-3 py-1 rounded red--text text--darken-4"
                style="border: 1px solid rgb(138, 27, 27)"
              >
                <v-icon color="red darken-4">mdi-information-outline</v-icon>
                <h5 class="d-inline-block pl-2">
                  visit created with same schedule
                </h5>
              </div>
            </v-col>
          </v-row>
          <table width="100%">
            <thead>
              <tr class="custom-border-bottom">
                <td class="font-size-16 font-weight-700">Primary</td>
                <td class="font-size-16 font-weight-700">S/N</td>
                <td class="font-size-16 font-weight-700">Start Date</td>
                <td class="font-size-16 font-weight-700">Day</td>
                <td class="font-size-16 font-weight-700">Start Time</td>
                <td class="font-size-16 font-weight-700">End Time</td>
                <!--  <td class="font-size-16 font-weight-700" width="100">Status</td> -->
              </tr>
            </thead>
            <tr
              v-for="(row, index) in preventiveSchedule"
              :key="index"
              :class="{ 'visit-row-hover': row.isEdited }"
            >
              <td
                class="font-size-14 font-weight-500"
                align="left"
                valign="middle"
                width="20"
              >
                <v-btn
                  icon
                  @click="
                    row.isEdited = 1;
                    updatePrimary(index);
                  "
                  v-if="index <= 1"
                >
                  <v-icon color="cyan" v-if="row.isPrimary"
                    >mdi-checkbox-marked</v-icon
                  >
                  <v-icon color="grey darken-1" v-else
                    >mdi-checkbox-blank-outline</v-icon
                  >
                </v-btn>
              </td>
              <td
                class="font-size-14 font-weight-500"
                align="left"
                valign="middle"
              >
                {{ index + 1 }}.
              </td>
              <td>
                <DatePicker
                  v-model="row.startDate"
                  key="visit-show-schedule-start-date"
                  id="visit-show-schedule-start-date"
                  :min-date="todayDate"
                  :max-date="maxDate"
                  placeholder="Start Date"
                  :rules="[validateRules.required(row.startDate, 'Start Date')]"
                  :disabled="row.isDisabled ? true : false"
                  v-on:change="
                    updateDay($event, index);
                    row.isEdited = 1;
                  "
                />
              </td>
              <td>
                <v-text-field
                  readonly
                  solo
                  flat
                  dense
                  :disabled="!row.status || row.isDisabled ? true : false"
                  filled
                  hide-details
                  :value="row.daysOfWeek"
                ></v-text-field>
              </td>
              <td>
                <TimePicker
                  :disabled="!row.status || row.isDisabled ? true : false"
                  v-model="row.startTime"
                  key="visit-show-schedule-start-time"
                  id="visit-show-schedule-start-time"
                  v-on:change="
                    row.isEdited = 1;
                    updateTimeValidation(row);
                  "
                  placeholder="Start Time"
                />
              </td>
              <td>
                <TimePicker
                  :disabled="!row.status || row.isDisabled ? true : false"
                  v-model="row.endTime"
                  key="visit-show-schedule-end-time"
                  id="visit-show-schedule-end-time"
                  v-on:change="
                    row.isEdited = 1;
                    updateTimeValidation(row);
                  "
                  placeholder="End Time"
                />
              </td>
              <!--  <td align="center" valign="middle">
                <v-switch
                  class="m-0 p-0"
                  color="cyan"
                  dense
                  hide-details
                  :false-value="0"
                  :true-value="1"
                  :disabled="row.isDisabled ? true : false"
                  v-on:change="row.isEdited = 1"
                  v-model="row.status"
                  inset
                ></v-switch>
              </td> -->
            </tr>
          </table>
        </v-form>
      </v-container>
    </template>
    <template v-slot:action>
      <v-btn
        class="mx-2 custom-grey-border custom-bold-button white--text"
        color="cyan"
        v-on:click="validateSchedule()"
      >
        Save
      </v-btn>
      <v-btn
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="$emit('close', true)"
      >
        Close
      </v-btn>
    </template>
  </Dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { cloneDeep, toSafeInteger } from "lodash";
import DatePicker from "@/view/components/QDatePicker.vue";
import TimePicker from "@/view/components/TimePicker.vue";
import Dialog from "@/view/pages/partials/Dialog.vue";
import {
  SET_RECURRING_DATE,
  UPDATE_SCHEDULE_STATE,
} from "@/core/services/store/preventive.module";
import moment from "moment-timezone";
import ManageSchedule from "@/core/plugins/job.plugin";
import { forEach } from "lodash";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";

export default {
  name: "job-ctx-show-schedule",
  mixins: [ValidationMixin],
  data() {
    return {
      formValid: true,
      lengthSchedule: false,
      todayDate: moment(new Date()).format("YYYY-MM-DD"),
      preventiveSchedule: [],
    };
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateTimeValidation(row) {
      if (row.startTime && row.endTime) {
        let starttime = moment(row.startTime, "hh:mm A");
        let endtime = moment(row.endTime, "hh:mm A");
        if (starttime.isAfter(endtime) || starttime.isSame(endtime)) {
          ErrorEventBus.$emit(
            "update:error",
            InitializeError("End Time must be after Start Time.")
          );
          return false;
        }
      }
    },
    updateDay(date, index) {
      this.preventiveSchedule[index].daysOfWeek = moment(date).format("dddd");
      if (
        !this.preventiveSchedule[index].startTime &&
        !this.preventiveSchedule[index].endTime
      ) {
        this.preventiveSchedule[index].startTime =
          this.preventiveSchedule[0].startTime;
        this.preventiveSchedule[index].endTime =
          this.preventiveSchedule[0].endTime;
      }
    },
    updatePrimary(index) {
      const _schedule = cloneDeep(this.preventiveSchedule);
      if (!_schedule[index].isPrimary) {
        let new_schedule = _schedule.map((row) => {
          return { ...row, isPrimary: 0 };
        });

        /* console.log(this.prventiveRecurringSchedule.end_mode) */
        /* let _startDate = ""; 
        if(_schedule.length > 2 && this.prventiveRecurringSchedule.end_mode == 2){
          let firstDate =  moment(_schedule[0].startDate,'YYYY-MM-DD');
          let lastDate =  moment(_schedule[1].endDate,'YYYY-MM-DD');
          let noOfDays = lastDate.diff(firstDate, 'days');
          const a = moment(_schedule[_schedule.length-1].startDate);
          _startDate = moment(a.add((noOfDays),'days')).format("YYYY-MM-DD");
        }
        if(this.prventiveRecurringSchedule.end_mode == 3){
          const a = moment(this.prventiveRecurringSchedule.endDate);
          _startDate = moment(a).format("YYYY-MM-DD");
        } */

        new_schedule[index].isPrimary = 1;
        if (index == 1) {
          new_schedule[index - 1].isDisabled = 1;
          new_schedule.push({
            daysOfWeek: "",
            startDateTime: "",
            endDateTime: "",
            startDate: "" /* _startDate */,
            endDate: new_schedule[index].endDate,
            startTime: "",
            endTime: "",
            status: 1,
            isEdited: 0,
            isPrimary: 0,
            isDisabled: 0,
          });
          this.lengthSchedule = true;
        }
        if (index == 0) {
          this.lengthSchedule = false;
          new_schedule[index].isDisabled = 0;
          new_schedule.pop();
        }
        this.preventiveSchedule = new_schedule;
      }
    },
    getDuration() {
      //
    },
    formatDate(date) {
      if (moment(date).isValid()) {
        return moment(date).format("DD MMMM YYYY hh:mm A");
      }
    },
    formatDateFormat(date) {
      if (moment(date).isValid()) {
        return moment(date).format("YYYY-MM-DD");
      }
    },
    formatTime(date) {
      if (moment(date).isValid()) {
        return moment(date).format("hh:mm A");
      }
    },
    validateSchedule() {
      let checkValidation = true;
      forEach(this.preventiveSchedule, (schedule, index) => {
        if (schedule.startTime && schedule.endTime) {
          let starttime = moment(schedule.startTime, "hh:mm A");
          let endtime = moment(schedule.endTime, "hh:mm A");
          if (starttime.isAfter(endtime) || starttime.isSame(endtime)) {
            ErrorEventBus.$emit(
              "update:error",
              InitializeError(
                ` Row (${index + 1}) End Time must be after Start Time.`
              )
            );
            checkValidation = false;
            return false;
          }
        }
      });
      if (checkValidation) {
        if (
          this.preventiveSchedule.length &&
          this.prventiveRecurringSchedule.end_mode == 2
        ) {
          const largestStartDate = this.preventiveSchedule
            .slice()
            .sort((a, b) => {
              return new Date(b.startDate) - new Date(a.startDate);
            })[0].startDate;
          let dateTime =
            largestStartDate + " " + this.prventiveRecurringSchedule.end_time;
          const scheduleManager = new ManageSchedule();
          const message = String(scheduleManager.message)
            .replace("{TYPE}", this.prventiveRecurringSchedule?.type?.text)
            .replace(
              "{START_DATE_TIME}",
              this.formatDate(this.prventiveRecurringSchedule.start_date)
            )
            .replace(
              "{OCCURRENCE}",
              this.prventiveRecurringSchedule.occurrence.length
            )
            .replace("{END_DATE_TIME}", this.formatDate(dateTime));
          this.$store.commit(UPDATE_SCHEDULE_STATE, {
            key: "dbPRecurringSchedule.message",
            value: message,
          });
          this.$store.commit(UPDATE_SCHEDULE_STATE, {
            key: "dbPRecurringSchedule.dbEndDate",
            value: this.formatDateFormat(largestStartDate),
          });
          this.$store.commit(UPDATE_SCHEDULE_STATE, {
            key: "dbPRecurringSchedule.dbEndTime",
            value: this.formatTime(this.prventiveRecurringSchedule.end_time),
          });
        }

        this.$refs["schedule-auto-generated-form"].validate();
        const formErrors = this.validateForm(
          this.$refs["schedule-auto-generated-form"]
        );
        if (formErrors.length) {
          for (let i = 0; i < formErrors.length; i++) {
            ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
          }
          return false;
        }
        this.$store.commit(SET_RECURRING_DATE, this.preventiveSchedule);
        this.$emit("next", true);
      }
    },
  },
  components: {
    Dialog,
    DatePicker,
    TimePicker,
  },
  computed: {
    ...mapGetters([
      "preventiveScheduleOutput",
      "prventiveRecurringSchedule",
      "preventiveEditData",
      "preventiveVisitCreateFlag",
    ]),
    dialogWidth() {
      return toSafeInteger((document.body.clientWidth / 100) * 70);
    },
    maxDate() {
      if (this.prventiveRecurringSchedule.end_mode == 3) {
        return this.prventiveRecurringSchedule.end_date;
      }
      return "";
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.preventiveSchedule = this.preventiveScheduleOutput;
    });
  },
};
</script>
